function visaBase2(prefix: string) {

  // PARAMETERS Menu Routes
  const PARAMETERS = `${prefix}/parameters`;


  // TRANSACTION Menu Routes
  const TRANSACTION_PATH = `${prefix}/transaction`;    
  const TRANSACTION_MENU = {
      ROOT: TRANSACTION_PATH,
      VALID_TRANSACTION_CONSULTING: `${TRANSACTION_PATH}/valid-transaction-consulting`,        
      VISA_TRANSACTION_STATUS: `${TRANSACTION_PATH}/visa-transaction-status`,        
      VISA_TRANSACTION_HISTORY: `${TRANSACTION_PATH}/visa-transaction-history`,
      OUTGOING_SUMMARY: `${TRANSACTION_PATH}/outgoing-summary`, 
      OUTGOING_SUMMARY_DETAILS: `${TRANSACTION_PATH}/outgoing-summary/details/`,              
      INCOMING_SUMMARY: `${TRANSACTION_PATH}/incoming-summary`,
      INCOMING_SUMMARY_DETAILS: `${TRANSACTION_PATH}/incoming-summary/details/`,
  };


  // ISSUER Menu Routes
  const ISSUER_PATH = `${prefix}/issuer`;    
  const PRESENTATION_PATH = `${ISSUER_PATH}/presentation`;
  const CHARGEBACK_PATH = `${ISSUER_PATH}/chargeback`;
  const CANCELLATION_PATH = `${CHARGEBACK_PATH}/cancellation`;
  const REQUEST_PATH = `${prefix}/request`;
  const ISSUER_MENU = {
      ROOT: ISSUER_PATH,
      PRESENTATION_MENU: {
          ROOT: PRESENTATION_PATH,
          PRESENTATION_CONSULTATION: `${PRESENTATION_PATH}/presentation-consultation`,
          REPRESENTATION_CONSULTATION: `${PRESENTATION_PATH}/representation-consultation`,
          PRESENTATION_CANCELLATION_CONSULTATION: `${PRESENTATION_PATH}/presentation-cancellation-consultation`,
      },
      CHARGEBACK_MENU: {
          ROOT: CHARGEBACK_PATH,
          CREATION: `${CHARGEBACK_PATH}/creation`,
          PRE_CONTROL_TREATMENT: `${CHARGEBACK_PATH}/pre-control-treatment`,
          CONSULTATION: `${CHARGEBACK_PATH}/consultation`,
          REPROCESSING_OPERATION:`${CHARGEBACK_PATH}/reprocessing-operation`,
          CANCELLATION_MENU:{
              ROOT: CANCELLATION_PATH,
              CREATION: `${CANCELLATION_PATH}/creation`,
              PRE_CONTROL_TREATMENT: `${CANCELLATION_PATH}/pre-control-treatment`,
              CONSULTATION: `${CANCELLATION_PATH}/consultation`,
              REPROCESSING_OPERATION:`${CANCELLATION_PATH}/reprocessing-operation`,
          },
      },
      REQUEST_MENU: {
          ROOT: REQUEST_PATH,
          CREATION: `${REQUEST_PATH}/creation`,
          PRE_CONTROL_TREATMENT: `${REQUEST_PATH}/pre-control-treatment`,
          CONSULTATION: `${REQUEST_PATH}/consultation`,
          REPROCESSING_OPERATION:`${REQUEST_PATH}/reprocessing-operation`,
      },
      CONSULTING_CONFIRMATION_REQUEST: `${ISSUER_PATH}/consulting-confirmation-request`,        
  };


  // FEES Menu Routes
  const FEES_PATH = `${prefix}/fees`;    
  const FEES_OUTGOING_PATH = `${FEES_PATH}/outgoing`;
  const FEES_INCOMING_PATH = `${FEES_PATH}/chargeback`;
  const FEES_MENU = {
      ROOT: FEES_PATH,
      OUTGOING_MENU: {
          ROOT: FEES_PATH,
          CREATION: `${FEES_OUTGOING_PATH}/creation`,
          CONSULTATION: `${FEES_OUTGOING_PATH}/consultation`,            
      },
      INCOMING_MENU: {
          ROOT: FEES_INCOMING_PATH,            
          CONSULTATION: `${FEES_INCOMING_PATH}/consultation`,
          CONSULTATION_DETAILS: `${FEES_INCOMING_PATH}/consultation/details/`,
      },
  };


  // MESSAGE Menu Routes
  const MESSAGE_PATH = `${prefix}/message`;    
  const MSG_OUTGOING_PATH = `${MESSAGE_PATH}/outgoing`;
  const MSG_INCOMING_PATH = `${MESSAGE_PATH}/incoming`;
  const MESSAGE_MENU = {
      ROOT: MESSAGE_PATH,
      OUTGOING_MENU: {
          ROOT: MSG_OUTGOING_PATH,
          CREATION: `${MSG_OUTGOING_PATH}/creation`,
          CONSULTATION: `${MSG_OUTGOING_PATH}/consultation`,            
      },
      INCOMING_MENU: {
          ROOT: MSG_INCOMING_PATH,            
          CONSULTATION: `${MSG_INCOMING_PATH}/consultation`,
      },
  };


  // BATCHES Menu Routes
  const BATCHES_PATH = `${prefix}/batches/`;
  
  const BATCHES = {
      ROOT: BATCHES_PATH,
      BATCHES_MONITORING: `${BATCHES_PATH}monitoring`,
      BATCHES_ERRORS: `${BATCHES_PATH}errors`,
      BATCHES_TRACES: `${BATCHES_PATH}traces`,
  }


  return {
      ROOT: prefix,
      PARAMETERS,
      TRANSACTION_MENU,
      ISSUER_MENU,
      FEES_MENU,
      MESSAGE_MENU,
      BATCHES,
  }
}


function interfaceM(prefix: string) {

  const AUTHORIZATION_PATH = `${prefix}/authorizations`;
  const INTERFACE_PATH = `${prefix}/interface`;
  
  return {
    ROOT: prefix,
    RISK_MANAGEMENT: `${prefix}/risk-management`,
    ROUTING: `${prefix}/routing`,
    BIN: `${prefix}/bin`,
    AUTHORIZATIONS: {
      ROOT: `${AUTHORIZATION_PATH}`,
      CONSULTING_AUTHORIZATIONS: `${AUTHORIZATION_PATH}/consulting-authorizations`,
      SAF_CONSULTATION: `${AUTHORIZATION_PATH}/saf-consultation`,
    },
    INTERFACE: {
      ROOT: `${INTERFACE_PATH}`,
      UPDATE: `${INTERFACE_PATH}/update`,
      HSM: `${INTERFACE_PATH}/hsm`,
      SUPERVISOR: `${INTERFACE_PATH}/supervisor`,
    },
    SUPERVISION: `${prefix}/supervision`,
  }
}


function gimac(prefix: string) {

  // TRANSACTION Menu Routes
  const TRANSACTION_PATH = `${prefix}/transaction/`;
  const TRANSACTION_MENU = {
      ROOT: TRANSACTION_PATH,
      CONSULTING_VALID_TRANSACTIONS: `${TRANSACTION_PATH}consulting-valid-transactions`,
      CONSULTING_GIMAC_TRANSACTIONS: `${TRANSACTION_PATH}consulting-gimac-transactions`,
      CONSULTING_VALID_SETTLEMENTS: `${TRANSACTION_PATH}consulting-valid-settlements`,
  };

  // ACQUIRER Menu Routes
  const ACQUIRER_PATH = `${prefix}/transaction/`;
  const ACQUIRER_MENU = {
      ROOT: ACQUIRER_PATH,
      TRANSACTION_ACQUISITION_NOTICE: `${ACQUIRER_PATH}transaction-acquisition-notice`,
      CAPTURE_OF_REPRESENTATION: `${ACQUIRER_PATH}capture-of-representation`,
      CAPTURE_OF_CANCELLATION: `${ACQUIRER_PATH}capture-of-cancellation`,
      CONSULTING_CANCELLATIONS: `${ACQUIRER_PATH}consulting-cancellations`,
  };

  // EMITTER Menu Routes
  const EMITTER_PATH = `${prefix}/emitter/`;
  const EMITTER_MENU = {
      ROOT: EMITTER_PATH,
      TRANSACTION_NOTICE: `${EMITTER_PATH}transaction-notice`,
      ENTER_A_CHARGEBACK: `${EMITTER_PATH}enter-a-chargeback`,
      CHARGEBACK_CANCELLATION: `${EMITTER_PATH}chargeback-cancellation`,
      CONSULTING_OF_CHARGEBACK: `${EMITTER_PATH}consulting-of-chargeback`,
      CONSULTING_OF_CHARGEBACK_CANCELLATIONS: `${EMITTER_PATH}consulting-of-chargeback-cancellations`,
  };

  // BATCHES Menu Routes
  const BATCHES_PATH = `${prefix}/batches/`;
  const BATCHES_MENU = {
      ROOT: BATCHES_PATH,
      BATCHES_MONITORING: `${BATCHES_PATH}monitoring`,
      BATCHES_ERRORS: `${BATCHES_PATH}errors`,
      BATCHES_TRACES: `${BATCHES_PATH}traces`,
  };

  return {
    ROOT: prefix,
    SETTINGS: `${prefix}/settings`,
    TRANSACTION_MENU,
    ACQUIRER_MENU,
    EMITTER_MENU,
    BATCHES_MENU
  };
}


export function interfaceManagement(prefix: string) {
  return {
    ROOT: prefix,
    // Visa Base II
    VISA_BASE_II: {
      ...visaBase2(`${prefix}/visa-base-2`)
    },
    // Interface Management
    INTERFACE: {
      ...interfaceM(`${prefix}/interface`)
    },
    // GIMAC
    GIMAC: {
      ...gimac(`${prefix}/gimac`)
    },
  }
}